import { useEffect, useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { createMold, updateMold } from "../api/molds";

function MoldModal({ data, onClose, onSaved }) {
  const [name, setName] = useState("");
  const [serialNo, setSerialNo] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setName(String(data?.name || ""));
    setSerialNo(String(data?.serial_no || ""));
    setError("");
  }, [data]);

  async function save() {
    const cleanName = name.trim();
    const cleanSerialNo = serialNo.trim();
    if (!cleanName) return setError("Kalıp adı zorunludur.");
    if (!cleanSerialNo) return setError("Seri no zorunludur.");

    setSaving(true);
    setError("");
    try {
      const payload = { name: cleanName, serial_no: cleanSerialNo };
      if (data?.id) await updateMold(data.id, payload);
      else await createMold(payload);
      await onSaved?.();
      onClose?.();
    } catch (err) {
      const message = err?.response?.data?.error?.message || err?.response?.data?.message || err?.message || "Kayıt kaydedilemedi.";
      setError(message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <Dialog open onClose={saving ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" fontWeight={800}>{data ? "Kalıp Düzenle" : "Yeni Kalıp"}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>Kalıbın tanım ve seri numarası bilgisini kaydedin.</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <TextField label="Kalıp Adı" value={name} onChange={(e) => setName(e.target.value)} required disabled={saving} autoFocus placeholder="Örn. 23 cm İzmir Derin" />
          <TextField label="Seri No" value={serialNo} onChange={(e) => setSerialNo(e.target.value)} required disabled={saving} placeholder="Örn. 863552" />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} color="inherit" disabled={saving}>İptal</Button>
        <Button onClick={save} variant="contained" disabled={saving}>{saving ? "Kaydediliyor..." : "Kaydet"}</Button>
      </DialogActions>
    </Dialog>
  );
}

export default MoldModal;
